var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.021 23.56C127.44 23.577 99.85 26.908 72.411 32.481C55.407 25.542 38.701 20.986 31.141 33.661C23.386 46.661 30.843 58.913 43.384 70.976C16.961 176.419 23.36 323.974 37.281 420.24C27.054 430.557 20.421 441.23 27.109 451.434C35.983 464.972 51.698 462.489 69.451 455.428C116.973 463.695 169.803 465.457 223.816 463.23C236.741 415.835 260.535 368.148 283.168 332.98C299.28 310.181 314.61 288.265 333.203 271.006C321.234 194.592 303.743 122.268 277.121 63.834C284.861 54.292 288.148 44.56 282.068 34.367C275.413 23.21 261.666 25.427 246.873 30.844C217.73 25.778 188.703 23.544 161.021 23.559Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.666 94.106C161.072 112.624 171.322 131.031 175.093 146.444L161.468 176.427L136.142 153.233C134.052 137.851 136.882 117.423 144.666 94.106Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.464 134.936C206.588 151.504 206.72 166.533 205.187 179.346L177.582 217.147L171.646 187.804L189.814 147.824C194.255 143.512 199.134 139.204 204.464 134.937Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.419 159.145L158.343 192.513L164.129 221.114L124.439 197.468C117.662 186.033 103.853 161.816 104.32 154.216C119.537 158.556 117.888 158.196 120.42 159.145Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.149 190.885C226.511 213.757 223.307 231.809 217.239 244.569L187.611 266.737L181.334 235.698L206.209 201.638C211.951 197.968 218.269 194.369 225.149 190.886Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.959 213.849C117.902 214.216 122.651 214.727 127.187 215.37L167.869 239.608L173.966 269.751L142.943 262.294C131.809 253.143 121.112 237.086 112.959 213.849Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.002 254.741C230.129 293.198 214.482 314.807 198.244 319.298L190.677 281.892L220.623 259.483C226.015 257.678 231.48 256.096 237.002 254.741Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.447 291.038C341.911 289.714 346.419 288.979 351.097 288.976C361.519 288.976 369.967 292.533 369.968 296.921C369.97 301.31 361.521 304.868 351.098 304.868C341.301 304.865 333.138 301.707 332.306 297.597C320.982 310.201 309.278 325.873 298.252 342.806C294.012 349.315 289.889 356.028 285.904 362.821C295.078 363.429 301.839 366.757 301.844 370.667C301.843 375.055 293.393 378.613 282.97 378.612C281.042 378.611 279.116 378.482 277.205 378.224C261.845 406.497 249.645 434.936 243.998 456.151C259.823 460.143 276.037 463.274 292.445 465.63L292.443 465.65C292.443 470.038 300.893 473.595 311.314 473.595C315.076 473.593 318.75 473.117 321.864 472.229C321.787 472.513 321.747 472.805 321.744 473.099C321.744 477.487 330.194 481.044 340.614 481.044C351.037 481.044 359.485 477.487 359.486 473.099C359.479 472.385 359.244 471.676 358.786 470.989C372.029 471.267 385.277 471.101 398.509 470.491C398.339 470.907 398.25 471.352 398.246 471.801C398.246 476.19 406.696 479.747 417.116 479.747C427.538 479.747 435.987 476.19 435.988 471.802C435.982 470.414 435.112 469.051 433.466 467.849C441.058 467.052 448.634 466.107 456.189 465.013C459.506 467.549 465.839 469.125 472.716 469.126C483.141 469.126 491.591 465.568 491.589 461.179C491.583 459.79 490.713 458.427 489.066 457.224C489.117 445.882 485.64 430.06 479.029 412.751C472.166 394.783 462.287 375.161 451.132 356.325C448.94 356.669 446.725 356.841 444.507 356.841C434.084 356.841 425.635 353.282 425.637 348.894C425.647 344.966 432.473 341.631 441.697 341.046C428.31 320.244 413.854 301.286 401.15 287.759C394.428 280.601 388.166 274.969 383.154 271.479C378.142 267.989 374.356 267.258 366.7 269.802C359.044 272.346 347.356 281.904 338.447 291.038Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.011 276.198L177.021 284.853L184.49 321.776C168.183 322.083 146.742 308.425 126.298 278.312C131.381 277.392 136.285 276.698 141.011 276.198Z",
    className: "",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.468 331.944C204.385 349.893 207.972 367.442 212.474 384.546L199.037 388.362C194.366 370.665 190.667 352.588 187.677 334.189Z",
    className: "selected",
    fill: "#f5a623",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.838 404.157C343.261 404.157 351.71 407.716 351.708 412.105C351.708 416.493 343.259 420.05 332.838 420.05C331.717 420.048 330.596 420.004 329.478 419.917C330.698 420.985 331.335 422.155 331.341 423.341C331.341 427.729 322.891 431.286 312.468 431.286C302.047 431.286 293.598 427.729 293.598 423.341C293.598 418.953 302.047 415.396 312.468 415.396C313.595 415.398 314.72 415.442 315.828 415.528C314.608 414.46 313.971 413.29 313.964 412.105C313.962 407.715 322.414 404.157 332.838 404.157Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.248 419.608C436.671 419.608 445.12 423.167 445.118 427.556C445.118 431.944 436.669 435.501 426.248 435.501C415.825 435.501 407.376 431.944 407.375 427.556C407.373 423.166 415.823 419.608 426.248 419.608Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.453 474.091C207.029 474.091 198.58 477.649 198.582 482.038C198.582 486.426 207.032 489.983 217.452 489.983C218.864 489.981 220.274 489.911 221.679 489.773C223.167 493.616 231.049 496.439 240.297 496.44C250.721 496.44 259.171 492.882 259.17 488.493C259.169 484.105 250.719 480.548 240.297 480.548C238.886 480.551 237.476 480.621 236.072 480.758C234.584 476.915 226.702 474.092 217.452 474.091Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlour);
export default __webpack_public_path__ + "static/media/Flour.ad196a6f1a42172f178889b8f2ba835a.svg";
export { ForwardRef as ReactComponent };